import { Stack } from '@chakra-ui/react';
import type { Team as TeamType } from 'types/cms/blocks';

import { Department } from './Department';
import { SectionHeader } from './SectionHeader';

interface TeamProps extends TeamType {
  pageTitle?: string;
}

export function Team({
  pageTitle,
  title,
  description,
  departments,
}: TeamProps) {
  return (
    <Stack className="section--team" mt="2xl" mb="lg" spacing="xl">
      {title && description && (
        <SectionHeader title={title} description={description} pb={0} />
      )}
      {departments?.map((department, index) => (
        <Department
          key={index}
          drawerHeader={{
            title: pageTitle,
            subTitle: department.title,
          }}
          {...department}
        />
      ))}
    </Stack>
  );
}
